import { useSessionListVersion } from '@/composition/hosts/session/session-list/useSessionListVersion';
import dynamic from 'next/dynamic';
import { type ComponentProps, type ComponentType } from 'react';
import type SessionsBarType from './side-bar';

const SessionsBar: ComponentType<ComponentProps<typeof SessionsBarType>> = dynamic(
  () => import('./side-bar')
);
const SessionsBarV2: ComponentType<ComponentProps<typeof SessionsBarType>> = dynamic(
  () => import('@/features/upcomingSessionTab/components/session-bar-v2')
);
const ConsolidatedSessionsBar: ComponentType<ComponentProps<typeof SessionsBarType>> =
  dynamic(() => import('@/features/consolidatedSessionsList/components/sessionBar'));

/**
 * Renders the appropriate sessions bar variant based on feature flags.
 * Shared by ResizableMenuPanels (flag-off path) and SessionsListPanelFixed (flag-on path).
 */
export const SessionsBarContent = () => {
  const sessionListVersion = useSessionListVersion();

  const bar =
    sessionListVersion === 'consolidated' ? (
      <ConsolidatedSessionsBar />
    ) : sessionListVersion === 'v2' ? (
      <SessionsBarV2 />
    ) : (
      <SessionsBar />
    );

  return <div className="flex size-full min-h-0 flex-col">{bar}</div>;
};
